import axios from '../utils/axios'
import {getLocal, getQueryString, setLocal} from "@/common/js/utils";
import {getNow} from "better-scroll/src/util/lang";
import {Dialog, Toast} from "vant";
import app from "../App.vue";
var qs = require('qs');

export function getWxUserInfo(sucdFunc) {
  let appid = getQueryString("state");
  let code = getQueryString("code");
  let cacheAppId = getLocal("login_cus_appid");

  if (!appid) {
    Toast("非法调用，请从微信端发起请求");
    return;
  }  //路径中不带appid，非法调用，直接返回不处理

  //微信服务器返回的字串带了 #与路由地址, 如：wx57e5cb2f979d370d#/CusDocList
  appid = appid.split('/')[0];
  appid = (appid.endsWith("#")) ? appid.substring(0, appid.length - 1) : appid;

  let needRefresh = false;
  //缓存没有公众号，或缓存中的公众号不是当前公号，需要重新登录
  if ((!cacheAppId) || (cacheAppId != appid))
    needRefresh = true;

  //缓存中找不到门诊号，重新登录
  const cacheShopCode = getLocal("login_cus_shop");
  if (!cacheShopCode)
    needRefresh = true;

  //缓存中找不到用户openid，重新登录
  const cacheOpenId = getLocal("login_cus_openid_" + cacheShopCode);
  if (!cacheOpenId)
    needRefresh = true;

  //不需要重新登录直接返回；
  if (!needRefresh) {
    sucdFunc();
    return true;
  }

  //没有获取到当前微信code时，重新申请微信授权
  if ((!code) || (code == '')) {
    //微信不认#
    let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri='
      + window.location.href.split('?')[0].replace("#", "%23")
      + '&response_type=code&scope=snsapi_userinfo&state=' + appid + '#wechat_redirect';
    window.location.href = url;
    return false;
  }

  let param = {method: "CustomerInfo", app: appid, code: code};
  axios.post(`/api/CustomerBussiness.ashx`, qs.stringify(param))
    .then(res => {
      if (res.Type == 0) {
        //处理后续缓存事宜
        let userInfo = JSON.parse(res.Detail);
        const shopcode = userInfo.shopcode;
        setLocal("login_cus_shop", shopcode);
        setLocal("login_cus_appid", appid);
        setLocal("login_cus_openid_" + shopcode, userInfo.openid);
        setLocal("login_cus_info_" + shopcode, res.Detail);
        sucdFunc();
        return true;
      } else {
        Toast(res.Message);
        return false;
      }
    })
    .catch(error => {
      console.log(error)
      return false;
    });
}

export function customerBussiness(typekey, method, params, sucdFunc) {
  const shopcode= getLocal("login_cus_shop");
  let realParam= {app: getLocal("login_cus_appid"),
    openid: getLocal("login_cus_openid_"+ shopcode),
    typekey: typekey, method: method};

  for(let ls in params){
    realParam[ls]= params[ls];
  }

  axios.post(`/api/CustomerBussiness.ashx`, qs.stringify(realParam))
      .then(res => {
        if (res.Type== 0) {
          sucdFunc(res.Detail);
          return true;
        }else{
          Toast(res.Message);
          return false;
        }
       })
      .catch(error => {
          console.log(error)
          return false;
       });
}

export function WeChatPayCall(typekey, params, sucdFunc) {
  const appid= getLocal("login_cus_appid");
  if (!appid){
    Toast("找不到门诊公众号，可能是因为没有取得您微信的授权");
    return;
  }

  const shopcode= getLocal("login_cus_shop");
  let realParam= { typekey:typekey, method:"WeChatPay", app: appid,
    openid: getLocal("login_cus_openid_"+ shopcode) };
  for(let ls in params){
    realParam[ls]= params[ls];
  }

  axios.post(`/api/CustomerBussiness.ashx`, qs.stringify(realParam))
    .then(res => {
      if (res.Type== 0) {
        sucdFunc(res.Detail);
        return true;
      }else{
        Toast(res.Message);
        return false;
      }
    })
    .catch(error => {
      console.log(error)
      return false;
    });
}

function WeChatAccessTick(srcUrl, sucdFunc){
  const shopcode= getLocal("login_cus_shop");
  let cacheAppId= getLocal("login_cus_appid");
  if (!cacheAppId){
    Toast("AccessTick: 无法获取用户信息，请重新打开！");
    return;
  }

  //合并传参调用服务器
  var realParam= { method:"getAccessTicket", srcUrl: srcUrl, app: cacheAppId,
                        openid: getLocal("login_cus_openid_"+ shopcode) };

  axios.post(`/api/CustomerBussiness.ashx`, qs.stringify(realParam))
    .then(res => {
      if (res.Type== 0) {
        sucdFunc(res.Detail);
        return true;
      }else{
        Toast(res.Message);
        return false;
      }
    })
    .catch(error => {
      console.log(error)
      return false;
    });
}

//分享菜单的处理
export function AuthWechatShare(appid, pathname, title, desc, imgUrl, srcSearch){
  WeChatAccessTick( window.location.href,
    function(data) {
      var ticket= JSON.parse(data);
      wx.config({
        debug:false,
        appId:ticket.AppId,
        timestamp:ticket.TimeStamp,
        nonceStr:ticket.NonceStr,
        signature:ticket.Access,
        jsApiList:[
          'updateAppMessageShareData',
          'updateTimelineShareData',
          'onMenuShareAppMessage',
          'onMenuShareTimeline',
          'scanQRCode',
          'checkJsApi']
      });
    });

  let urlSearch="?state="+ appid+ "&share=1&"+ srcSearch;
  wx.ready(function () {
    let url= "http://"+ window.location.host+ "/#/"+ pathname+ urlSearch;
    wx.onMenuShareAppMessage({
      title: title,
      desc: desc,
      link: url,
      imgUrl: "http://huyi-1252763274.cossh.myqcloud.com/"+ imgUrl,
      type: '',
      dataUrl: '',
      success: function () {
      }
    });
  });
}
